import { render, staticRenderFns } from "./ArtistPromo.vue?vue&type=template&id=27e5e426&scoped=true"
import script from "./ArtistPromo.vue?vue&type=script&lang=js"
export * from "./ArtistPromo.vue?vue&type=script&lang=js"
import style0 from "./ArtistPromo.vue?vue&type=style&index=0&id=27e5e426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5e426",
  null
  
)

export default component.exports